import React from 'react';

const PHONE_DIGITS = '359883485326';
const WA_URL = `https://wa.me/${PHONE_DIGITS}`;
const VIBER_URL = `viber://chat?number=%2B${PHONE_DIGITS}`;

const COPY = {
  bg: {
    whatsapp: 'Пиши ни в WhatsApp',
    viber: 'Пиши ни във Viber',
    aria: 'Бързи съобщения',
  },
  en: {
    whatsapp: 'Chat on WhatsApp',
    viber: 'Chat on Viber',
    aria: 'Quick messaging',
  },
};

export const FloatingContactButton = ({ language = 'bg' }) => {
  const copy = COPY[language] || COPY.bg;

  return (
    <div
      className="fixed right-4 sm:right-6 bottom-4 sm:bottom-6 z-20 flex flex-col gap-3"
      role="group"
      aria-label={copy.aria}
    >
      <FloatingLink
        href={VIBER_URL}
        label={copy.viber}
        bg="bg-[#7360F2]"
        hoverBg="hover:bg-[#5E4CD6]"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
          <path d="M18.23 3.49C16.47 1.87 13.82 1.06 12.05 1 10.21.94 6.5 1.27 4.56 3.09 2.61 4.91 2.1 7.58 2.05 10.91c-.05 3.33.05 6.58 1.9 8.55.88.93 2.02 1.45 3.35 1.45h.02l-.46 2.2c0 .27.18.53.49.64.08.03.16.04.24.04.22 0 .43-.1.57-.29l2.66-3.6c.43.04.85.06 1.26.06 1.8 0 4.92-.2 6.99-2.14 2.06-1.93 2.27-5.2 2.31-8.47.04-3.27-.61-5.4-2.37-7.02zm-.59 6.55c-.04 2.85-.15 5.44-1.64 6.83-1.62 1.52-4.57 1.63-5.97 1.63-.52 0-1.04-.04-1.56-.11a.72.72 0 00-.66.29l-1.82 2.46.31-1.48a.73.73 0 00-.14-.6.73.73 0 00-.56-.27c-1.22 0-2.16-.37-2.84-1.12-1.41-1.56-1.49-4.33-1.45-7.27.04-2.94.34-5.36 1.88-6.8C6.82 2.25 10.18 2.1 12.05 2.15c1.92.06 4.38.79 5.72 2.16 1.39 1.42 1.91 3.35 1.87 5.73zm-2.32 4.49c-.34.48-.96.92-1.58 1.04-.41.08-.94.13-2.73-.52-2.24-.81-3.68-3.09-3.79-3.24-.11-.15-.9-1.2-.9-2.29 0-1.09.57-1.63.77-1.85.2-.22.44-.28.59-.28h.43c.14 0 .32-.05.5.38.19.44.64 1.52.69 1.63.06.11.1.24.02.39-.08.15-.12.24-.23.37-.11.13-.24.29-.35.39-.11.1-.23.21-.1.43.14.22.61.92 1.31 1.49.9.73 1.66.96 1.89 1.07.23.11.36.09.49-.05.13-.14.57-.63.72-.85.15-.22.3-.18.51-.11.2.08 1.29.55 1.51.65.22.1.36.16.42.25.06.09.06.53-.19 1.01zm-3.37-9.38c2.9.12 4.42 1.83 4.46 4.64 0 .27-.23.5-.5.5h-.01c-.28 0-.5-.24-.5-.51-.03-2.28-1.13-3.52-3.49-3.63-.28-.01-.49-.24-.48-.52.01-.27.25-.49.52-.48zm.17 1.95c1.76.08 2.62.98 2.66 2.78.01.28-.22.51-.5.51h-.01c-.27 0-.49-.22-.5-.49-.03-1.25-.56-1.8-1.7-1.85-.28-.01-.49-.25-.48-.52.01-.28.25-.49.53-.43zm.3 1.98c1.16.05 1.35.25 1.39 1.44.01.28-.21.51-.49.52h-.02c-.27 0-.49-.21-.5-.48-.02-.53-.06-.54-.42-.55-.28-.01-.49-.25-.48-.52.01-.28.24-.49.52-.41z" />
        </svg>
      </FloatingLink>

      <FloatingLink
        href={WA_URL}
        label={copy.whatsapp}
        bg="bg-[#25D366]"
        hoverBg="hover:bg-[#1FA851]"
        external
      >
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347zM12 2C6.48 2 2 6.48 2 12c0 1.76.46 3.41 1.26 4.84L2 22l5.26-1.38A9.96 9.96 0 0012 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18.08a8.05 8.05 0 01-4.1-1.12l-.29-.17-3.02.79.8-2.95-.19-.3A8.07 8.07 0 014 12c0-4.45 3.63-8.08 8.08-8.08S20.08 7.55 20.08 12s-3.63 8.08-8.08 8.08z" />
        </svg>
      </FloatingLink>
    </div>
  );
};

const FloatingLink = ({ href, label, bg, hoverBg, children, external }) => (
  <a
    href={href}
    target={external ? '_blank' : undefined}
    rel={external ? 'noopener noreferrer' : undefined}
    aria-label={label}
    className={`group relative inline-flex items-center justify-center w-12 h-12 rounded-full text-white ${bg} ${hoverBg} shadow-lg shadow-ink/20 transition-all duration-300 ease-out-quart hover:scale-105 active:scale-95 focus-visible:outline-offset-4`}
  >
    {children}
    <span
      className="pointer-events-none absolute right-full mr-3 whitespace-nowrap px-3 py-1.5 bg-ink text-paper font-mono text-[0.68rem] uppercase tracking-[0.18em] opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 group-focus-visible:opacity-100 group-focus-visible:translate-x-0 transition-all duration-300 rounded-xs"
      role="tooltip"
    >
      {label}
    </span>
  </a>
);
